import { render, staticRenderFns } from "./DatePickerForm.vue?vue&type=template&id=5a4ef65f&"
import script from "./DatePickerForm.vue?vue&type=script&lang=js&"
export * from "./DatePickerForm.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
installComponents(component, {VDatePicker})
